import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { SidebarContext } from "../context/SidebarContext";
import StorageServices from "../services/StorageServices";

function AccessibleNavigationAnnouncer() {
  const [message, setMessage] = useState("");
  const location = useLocation();
  const initialLoadRef = useRef(true);

  const { toggleTrue, toggleFalse, toggleAutoClose, setCollapsed } =
    useContext(SidebarContext);

  // Handle screen reader announcements on navigation
  useEffect(() => {
    if (location.pathname.slice(1)) {
      setTimeout(
        () => setMessage(`Navigated to ${location.pathname.slice(1)} page.`),
        500
      );
    } else {
      setMessage("");
    }
  }, [location]);

  // Combined effect to handle both initial load and navigation
  useEffect(() => {
    const autoCollapsePages = [
      "/reporting/",
      "reports/create",
      "/reports/dashboards/",
      "reports/papia",
    ];
    const currentPath = location.pathname;
    const shouldAutoCollapse = autoCollapsePages.some((snippet) =>
      currentPath.includes(snippet)
    );

    // Add a small delay on initial load to ensure context is ready
    const timeoutDelay = initialLoadRef.current ? 100 : 0;

    setTimeout(() => {
      //
      if (shouldAutoCollapse) {
        setCollapsed(false); // Set collapsed state directly
        toggleAutoClose(true); // Set auto-close
      } else {
        const autocloseStatus = StorageServices.get(
          "SB-Sidebar-Collapse-Autoclose"
        )
          ? JSON.parse(StorageServices.get("SB-Sidebar-Collapse-Autoclose"))
          : false;

        if (autocloseStatus) {
          // console.log("Auto-close enabled - collapsing sidebar");
          setCollapsed(true);
          toggleTrue();
          toggleAutoClose(false);
        }
      }

      // Mark initial load as complete
      if (initialLoadRef.current) {
        initialLoadRef.current = false;
      }
    }, timeoutDelay);
  }, [location, setCollapsed, toggleTrue, toggleFalse, toggleAutoClose]);

  return (
    <span
      className="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {message}
    </span>
  );
}

export default AccessibleNavigationAnnouncer;
